var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "senior-column",
      attrs: {
        title: "表格列配置",
        visible: _vm.seniorColumnDrawer,
        direction: "rtl",
        size: "60%",
        wrapperClosable: false
      },
      on: {
        close: function($event) {
          ;(_vm.seniorColumnDrawer = false), (_vm.radioFlage = false)
        }
      }
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-main",
            { staticStyle: { height: "98vh", padding: "0px" } },
            [
              _c("vxe-toolbar", {
                ref: "conditionTable1",
                staticStyle: { "padding-right": "10px" },
                attrs: {
                  perfect: "",
                  custom: "",
                  refresh: { query: _vm.handleSearchTableLoad }
                },
                scopedSlots: _vm._u([
                  {
                    key: "buttons",
                    fn: function() {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "addButton",
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              icon: "el-icon-plus",
                              type: "primary",
                              size: "small"
                            },
                            on: { click: _vm.seniorColumngAdd }
                          },
                          [_vm._v("添加字段")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "saveButton",
                            staticStyle: { "margin-left": "10px" },
                            attrs: {
                              icon: "el-icon-check",
                              size: "small",
                              type: "primary"
                            },
                            on: { click: _vm.seniorColumnSave }
                          },
                          [_vm._v("保存信息")]
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom",
                              width: "200",
                              trigger: "click"
                            },
                            on: { hide: _vm.handlePrefix }
                          },
                          [
                            _c("el-input", {
                              staticStyle: {
                                width: "100%",
                                "font-size": "16px"
                              },
                              attrs: {
                                resize: "none",
                                rows: 4,
                                placeholder: "请输入表名称"
                              },
                              model: {
                                value: _vm.prefix,
                                callback: function($$v) {
                                  _vm.prefix = $$v
                                },
                                expression: "prefix"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticClass: "blackButton",
                                staticStyle: { "margin-left": "10px" },
                                attrs: {
                                  slot: "reference",
                                  size: "small",
                                  icon: "el-icon-sort-down",
                                  type: "primary"
                                },
                                slot: "reference"
                              },
                              [_vm._v("字段标题")]
                            )
                          ],
                          1
                        ),
                        _vm.$hasBtnPermiss("SeniorColumnDeleteUserConfig")
                          .isShow
                          ? _c(
                              "el-button",
                              {
                                staticClass: "cancellationButton",
                                staticStyle: { "margin-left": "10px" },
                                attrs: {
                                  size: "small",
                                  icon: "el-icon-delete",
                                  type: "warning"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.seniorColumnDeleteAll(false)
                                  }
                                }
                              },
                              [_vm._v("删除用户配置")]
                            )
                          : _vm._e(),
                        _vm.$hasBtnPermiss("SeniorColumnDeleteAll").isShow
                          ? _c(
                              "el-button",
                              {
                                staticClass: "cancellationButton",
                                staticStyle: { "margin-left": "10px" },
                                attrs: {
                                  size: "small",
                                  icon: "el-icon-delete",
                                  type: "danger"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.seniorColumnDeleteAll(true)
                                  }
                                }
                              },
                              [_vm._v("删除全部配置")]
                            )
                          : _vm._e(),
                        _c(
                          "el-radio-group",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "small", fill: "#C71585" },
                            model: {
                              value: _vm.radioFlage,
                              callback: function($$v) {
                                _vm.radioFlage = $$v
                              },
                              expression: "radioFlage"
                            }
                          },
                          [
                            _c("el-radio-button", { attrs: { label: false } }, [
                              _vm._v("字段标题补充")
                            ]),
                            _c("el-radio-button", { attrs: { label: true } }, [
                              _vm._v("字段标题覆盖")
                            ])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _c(
                "vxe-table",
                {
                  ref: "xTable",
                  attrs: {
                    border: "",
                    resizable: "",
                    height: "90%",
                    size: "medium",
                    align: "center",
                    "highlight-current-row": "",
                    "highlight-hover-row": "",
                    "show-overflow": "",
                    "auto-resize": "",
                    "keep-source": "",
                    stripe: "",
                    loading: _vm.loading,
                    data: _vm.mainTable,
                    "edit-rules": _vm.validRules,
                    "sort-config": { trigger: "cell" },
                    "mouse-config": { selected: true },
                    "edit-config": {
                      trigger: "click",
                      mode: "row",
                      showStatus: true
                    },
                    "radio-config": { labelField: "name", trigger: "row" },
                    "checkbox-config": { checkField: "checked", trigger: "row" }
                  }
                },
                [
                  _c("vxe-table-column", {
                    attrs: {
                      field: "ORD_IDX",
                      title: "序号",
                      "min-width": "120",
                      sortable: "",
                      "edit-render": {
                        name: "$input",
                        props: { type: "number", min: 1 }
                      }
                    }
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "FIELD_NAME",
                      title: "字段名称",
                      "min-width": "160",
                      sortable: "",
                      "edit-render": { name: "select", options: _vm.mainKeys }
                    }
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "FIELD_CAPTION",
                      title: "字段标题",
                      "min-width": "140",
                      sortable: "",
                      "edit-render": { name: "input", props: {} }
                    }
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "FIELD_WIDTH",
                      title: "字段宽度",
                      "min-width": "120",
                      sortable: "",
                      "edit-render": {
                        name: "$input",
                        props: { type: "number", min: 0 }
                      }
                    }
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      sortable: "",
                      "min-width": "150",
                      field: "IS_VISIBLE",
                      title: "是否显示"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("el-switch", {
                              attrs: {
                                "active-text": _vm.$t("publics.btn.yes"),
                                "inactive-text": _vm.$t("publics.btn.no"),
                                "active-color": "#13ce66",
                                "inactive-color": "#cccccc",
                                "active-value": "Y",
                                "inactive-value": "N"
                              },
                              model: {
                                value: row.IS_VISIBLE,
                                callback: function($$v) {
                                  _vm.$set(row, "IS_VISIBLE", $$v)
                                },
                                expression: "row.IS_VISIBLE"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }